import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksMaterials(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		options
	)
}

function _getOrderGeneratorsFieldsWorksMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
		options
	)
}

function _createOrderGeneratorsFieldsWorksMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
		options
	)
}

function _putOrderGeneratorsFieldsWorksMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PUT_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksMaterial(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIALS]: _getOrderGeneratorsFieldsWorksMaterials,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: _getOrderGeneratorsFieldsWorksMaterial,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: _createOrderGeneratorsFieldsWorksMaterial,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PUT_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: _putOrderGeneratorsFieldsWorksMaterial,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: _patchOrderGeneratorsFieldsWorksMaterial,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: _deleteOrderGeneratorsFieldsWorksMaterial,
}